import { createContext } from "react";
import { ArrayPath, UseFieldArrayReturn } from "react-hook-form";

export type EditableTableContextValue<T extends object> = {
  methods?: UseFieldArrayReturn<T>;
  name: ArrayPath<T>;
  disabled?: boolean;
};

const EditableTableContext = createContext<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  EditableTableContextValue<any>
>({
  methods: undefined,
  name: "",
  disabled: false,
});

export default EditableTableContext;
